import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import MissionCard from '../../../components/MissionsComponents/MissionCard';
import MissionFilter from '../../../components/MissionsComponents/MissionFilter';
import ChildPages from '../../../components/ChildPages';
import ProgressCard from '../../../components/MissionsComponents/ProgressCard';
import ChildHeader from '../../../components/ChildHeader';
import FirstLoggin from '../../../components/FirstLoggin';

import DexterityIcon from '../../../assets/missions/dexterity2.png'
import IntelligenceIcon from '../../../assets/missions/Intelligence2.png'
import DisciplineIcon from '../../../assets/missions/discipline2.png'

import formatMission from "../../../utils/formatMission";
import formatPeriod from "../../../utils/formatPeriod";

import { useListChildren } from '../../../hooks/ParentContext';
import { useAuth } from '../../../hooks/AuthContext';
import { useFilter } from '../../../hooks/FilterContext';

import api from '../../../services/api';

import { Container, Content } from './styles';
import Loader from '../../../components/Loader';
import ResponsiveFooter from '../../../components/ResponsiveFooter';

const Dashboard = () => {
  const { user } = useAuth();
  const { selectedOne } = useListChildren();
  const { skillValue, statusValue } = useFilter();
  const [loading, setLoading] = useState(true);
  const [missionLoading, setMissionLoading] = useState(true);

  const [child, setChild] = useState({});
  const [missions, setMissions] = useState([]);


  const token = localStorage.getItem("@Ocariot:token");

  useEffect(() => {
    if (selectedOne._id !== undefined && (user.type == 1)) {
      setLoading(true);
      api.get(`child/${selectedOne._id}`, {
        params: {
          filter: { q: [true, skillValue.name, statusValue.name], qField: ["percentage", "skill", "status"] },
          // pagination: { page, perPage: 11 },
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        setChild(res.data.data);
        api.put(`mission/update/${res.data.data.parents}`, {}, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        })
        setLoading(false)
      }).catch((err) => {
        toast.error("Erro ao carregar crianças");
        console.log(err);
        setLoading(false)
      });


    }
  }, [selectedOne])

  useEffect(() => {
    if (selectedOne._id !== undefined && (user.type == 1)) {
      setMissionLoading(true);
      api.get(`child/${selectedOne._id}`, {
        params: {
          filter: { q: [skillValue.name, statusValue.name], qField: ["skill", "status"] },
          // pagination: { page, perPage: 11 },
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        setMissions(res.data.data.missions);
        setMissionLoading(false)
        console.log(res.data.data);
        api.put(`mission/update/${res.data.data.parents}`, {}, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        })
      }).catch((err) => {
        toast.error("Erro ao carregar missões");
        console.log(err);
        setMissionLoading(false)
      });
    }
  }, [selectedOne, skillValue, statusValue])
  return (
    <Container>
      {(user.type == 1) && <FirstLoggin />}
      <Content>
        <div className="first-header-line">
          <ChildHeader />
        </div>
        <div className="body">
          <div className="pages-child">
            <ChildPages active="dashboard" />
            <p>Acompanhe o progresso do participante no jogo</p>
          </div>
          <div className="points">
            <ProgressCard
              isloading={loading}
              name="Pontos"
              text={(child.score === 0) ? "0" : child.score}
              value={(child.score === 0) ? 1 : 100}
              percentage={child.score}
            />

            <ProgressCard
              isloading={loading}
              name="Destreza"
              icon={DexterityIcon}
              value={(child.score === 0) ? 1 : (child.percentage?.Destreza * 100)}
              percentage={(child.score === 0) ? "0%" : `${((child.percentage?.Destreza) * 100).toFixed(2)}%`}
            />

            <ProgressCard
              isloading={loading}
              name="Inteligencia"
              icon={IntelligenceIcon}
              value={(child.score === 0) ? 1 : (child.percentage?.Inteligência * 100)}
              percentage={(child.score === 0) ? "0%" : `${((child.percentage?.Inteligência) * 100).toFixed(2)}%`}
            />

            <ProgressCard
              isloading={loading}
              name="Disciplina"
              icon={DisciplineIcon}
              value={(child.score === 0) ? 1 : (child.percentage?.Disciplina * 100)}
              percentage={(child.score === 0) ? "0%" : `${((child.percentage?.Disciplina) * 100).toFixed(2)}%`}
            />
          </div>
          <MissionFilter />
          <div className="scroll-body">
            {!missionLoading ? (
              (missions.length !== 0) ? (
                missions.map(mission => (
                  <MissionCard
                    skillIcon={mission._id.skill}
                    childId={child._id}
                    id={mission._id._id}
                    key={mission._id._id}
                    title={mission._id.title}
                    period={formatPeriod(mission._id.duration, mission.start)}
                    goal={formatMission(mission._id.goals)}
                    duration={mission._id.duration}
                    isFitbitGoal={(mission._id.goals.generalGoal) ? false : true}
                    skill={mission._id.skill}
                    status={mission.status}
                    owner={mission._id.createdBy?.username}
                    recomendation={mission._id.recommendationParent}
                  />
                ))
              ) : (
                skillValue || statusValue ?
                  <p>Essa criança ainda não possui missões com esse filtro</p> :
                  <p>Essa criança ainda não possui missões</p>
              )
            ) : (
              <div>
                <Loader color="blue" />
              </div>
            )}
            {!loading && <ResponsiveFooter />}
          </div>
        </div>
      </Content>
    </Container >
  );
}

export default Dashboard;